export class APIError extends Error {
  status: number
  code: string

  constructor(status: number, code: string, message: string) {
    super(message)
    this.status = status
    this.code = code
  }
}

export function readCookie(name: string, source = document.cookie): string {
  const prefix = `${encodeURIComponent(name)}=`
  for (const part of source.split(';')) {
    const candidate = part.trim()
    if (candidate.startsWith(prefix)) return decodeURIComponent(candidate.slice(prefix.length))
  }
  return ''
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers)
  if (init.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json')
  const method = (init.method ?? 'GET').toUpperCase()
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    const csrf = readCookie('authem_session_csrf')
    if (csrf) headers.set('X-CSRF-Token', csrf)
  }
  const response = await fetch(path, { ...init, headers, credentials: 'same-origin' })
  const contentType = response.headers.get('content-type') ?? ''
  const payload = contentType.includes('application/json') ? await response.json() : undefined
  if (!response.ok) {
    throw new APIError(response.status, payload?.code ?? payload?.error ?? 'request_failed', payload?.detail ?? 'The request could not be completed.')
  }
  return payload as T
}

export const postJSON = <T>(path: string, body: unknown) => api<T>(path, { method: 'POST', body: JSON.stringify(body) })
export const putJSON = <T>(path: string, body: unknown) => api<T>(path, { method: 'PUT', body: JSON.stringify(body) })
export const deleteJSON = <T>(path: string) => api<T>(path, { method: 'DELETE' })
